import { Injectable } from '@angular/core';
import { OdxImport } from 'app/app-model/odx-import/odx-import';
import { Observable } from 'rxjs';

import { ApiProxyService } from '../modules/shared/services/api-proxy.service';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class OdxImportService {

    constructor(private apiProxy: ApiProxyService, private configService: ConfigService) { }

    getOdxImports(specificationVersionId: number): Observable<OdxImport[]> {
        return this.apiProxy.get<OdxImport[]>(this.configService.apiUrl + 'odximports?specificationVersionId=' + specificationVersionId);
    }
}
